import { createContext, useContext } from 'react'
import type { SupportLane } from './support'

/**
 * The lanes `support_lanes()` reported, for anything inside the shell that
 * renders a routing step — the drawer and, since 22 Sep, the Ask One panel on
 * #/wiki. AppShell loads them ONCE and provides them; a second fetch would be a
 * second answer to "is anybody there" that could disagree with the first.
 *
 * Its own module rather than AppShell.tsx so a component can read it WITHOUT
 * importing the shell — the shell imports an SVG the test bundler cannot
 * resolve, and a component that imports the shell is one the suite cannot
 * mount.
 *
 * Undefined means NOT LOADED, which `intentRouting` treats as closed.
 *
 * ── THE PROVIDER IS BELOW THE ROUTE, SO CALL THIS FROM A CHILD ──────────────
 *
 * A route renders `<AppShell>` from its own body. A hook called in that body is
 * ABOVE the provider and gets the default. That is how #/wiki's Ask One button
 * did nothing for five days (see `useAskOne`).
 */
export const OpenLanesContext = createContext<readonly SupportLane[] | undefined>(undefined)

export function useOpenLanes(): readonly SupportLane[] | undefined {
  return useContext(OpenLanesContext)
}
